import { Pegasus } from 'corso-types';
import DescriptionList from '~/components/DescriptionList';
import { useIntegrationSettingsData } from '~/hooks/useIntegrationSettings';

export default function EventCreateGorgiasTicketDisplay({
  params,
}: {
  params: Pegasus.EventCreateGorgiasTicket['params'];
}) {
  const { data: { gorgiasConfig } = {} } = useIntegrationSettingsData();

  const teams =
    gorgiasConfig?.connected === true ? (gorgiasConfig.teams ?? []) : [];

  const { subject, senderEmail, shouldAssignSender, assigneeTeamId, tags } =
    params;

  return (
    <DescriptionList
      layoutType="list"
      descriptions={[
        { term: 'Ticket Subject', details: subject },
        { term: 'Sender Email', details: senderEmail },
        { term: 'Assign Sender', details: shouldAssignSender ? 'Yes' : 'No' },
        {
          term: 'Assignee Team',
          details: assigneeTeamId
            ? (teams.find(({ id }) => id === assigneeTeamId)?.name ??
              `Team Id: ${assigneeTeamId}`)
            : 'None',
        },
        {
          term: 'Tags',
          details: tags?.length ? tags.join(', ') : 'None',
        },
      ]}
    />
  );
}
